import type { Currency } from 'models/currency';
import type { ExtraFee } from 'models/extraFee';
import type { Tax } from 'models/tax';
import { useMemo } from 'react';

export type Amount = {
  value: number;
  currency?: string | Currency;
};

export function useAccountant({
  amount,
  fees,
  extraFees = [],
  taxes = [],
}: {
  amount: Amount;
  fees?: Amount;
  extraFees?: ExtraFee[];
  taxes?: Tax[];
}) {
  const {
    total,
    totalWithTaxesAndFees,
    totalTaxes,
    totalFlywireFees,
    totalInternationalFees,
  } = useMemo(() => {
    const amountValue = amount?.value || 0;
    const totalFlywireFees = fees?.value || 0;
    const taxesArray = taxes || [];
    const extraFeesArray = extraFees || [];
    const totalTaxes = taxesArray.reduce((total, tax) => {
      return total + tax.amount;
    }, 0);

    const totalInternationalFees = extraFeesArray.reduce((total, extraFee) => {
      const {
        price: { value },
      } = extraFee;
      return total + value;
    }, 0);

    const totalWithTaxesAndFees =
      amountValue + totalTaxes + totalFlywireFees + totalInternationalFees;

    return {
      total: amountValue,
      totalWithTaxesAndFees,
      totalTaxes,
      totalFlywireFees,
      totalInternationalFees,
    };
  }, [amount, fees, extraFees, taxes]);

  return {
    total,
    totalWithTaxesAndFees,
    totalTaxes,
    totalFlywireFees,
    totalInternationalFees,
  };
}
